"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_DASHBOARD_FILTER = exports.DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR = exports.DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS = exports.DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED = exports.DASHBOARD_SUBSCRIPTIONS_ERROR = exports.DASHBOARD_SUBSCRIPTIONS_SUCCESS = exports.DASHBOARD_SUBSCRIPTIONS_REQUESTED = exports.DASHBOARD_VIEW_CHANGED = exports.SET_DASHBOARD = exports.DASHBOARD_FILTER_CHANGED = exports.SET_DASHBOARD_FILTER = exports.DASHBOARD_DELETE_ERROR = exports.DASHBOARD_DELETE_SUCCESS = exports.DASHBOARD_DELETE_REQUESTED = exports.DASHBOARD_EDIT_ERROR = exports.DASHBOARD_EDIT_SUCCESS = exports.DASHBOARD_EDIT_REQUESTED = exports.DASHBOARD_ADD_ERROR = exports.DASHBOARD_ADD_SUCCESS = exports.DASHBOARD_ADD_REQUESTED = exports.DASHBOARD_ERROR = exports.DASHBOARD_SUCCESS = exports.DASHBOARD_REQUESTED = void 0;
// Events API - DASHBOARD Entity
var DASHBOARD_REQUESTED = 'DASHBOARD_REQUESTED';
exports.DASHBOARD_REQUESTED = DASHBOARD_REQUESTED;
var DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
exports.DASHBOARD_SUCCESS = DASHBOARD_SUCCESS;
var DASHBOARD_ERROR = 'DASHBOARD_ERROR';
exports.DASHBOARD_ERROR = DASHBOARD_ERROR;
var DASHBOARD_ADD_REQUESTED = 'DASHBOARD_ADD_REQUESTED';
exports.DASHBOARD_ADD_REQUESTED = DASHBOARD_ADD_REQUESTED;
var DASHBOARD_ADD_SUCCESS = 'DASHBOARD_ADD_SUCCESS';
exports.DASHBOARD_ADD_SUCCESS = DASHBOARD_ADD_SUCCESS;
var DASHBOARD_ADD_ERROR = 'DASHBOARD_ADD_ERROR';
exports.DASHBOARD_ADD_ERROR = DASHBOARD_ADD_ERROR;
var DASHBOARD_EDIT_REQUESTED = 'DASHBOARD_EDIT_REQUESTED';
exports.DASHBOARD_EDIT_REQUESTED = DASHBOARD_EDIT_REQUESTED;
var DASHBOARD_EDIT_SUCCESS = 'DASHBOARD_EDIT_SUCCESS';
exports.DASHBOARD_EDIT_SUCCESS = DASHBOARD_EDIT_SUCCESS;
var DASHBOARD_EDIT_ERROR = 'DASHBOARD_EDIT_ERROR';
exports.DASHBOARD_EDIT_ERROR = DASHBOARD_EDIT_ERROR;
var DASHBOARD_DELETE_REQUESTED = 'DASHBOARD_DELETE_REQUESTED';
exports.DASHBOARD_DELETE_REQUESTED = DASHBOARD_DELETE_REQUESTED;
var DASHBOARD_DELETE_SUCCESS = 'DASHBOARD_DELETE_SUCCESS';
exports.DASHBOARD_DELETE_SUCCESS = DASHBOARD_DELETE_SUCCESS;
var DASHBOARD_DELETE_ERROR = 'DASHBOARD_DELETE_ERROR';
exports.DASHBOARD_DELETE_ERROR = DASHBOARD_DELETE_ERROR;
var SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER';
exports.SET_DASHBOARD_FILTER = SET_DASHBOARD_FILTER;
var DASHBOARD_FILTER_CHANGED = 'DASHBOARD_FILTER_CHANGED';
exports.DASHBOARD_FILTER_CHANGED = DASHBOARD_FILTER_CHANGED;
var SET_DASHBOARD = 'SET_DASHBOARD';
exports.SET_DASHBOARD = SET_DASHBOARD;
var DASHBOARD_VIEW_CHANGED = 'DASHBOARD_VIEW_CHANGED';
exports.DASHBOARD_VIEW_CHANGED = DASHBOARD_VIEW_CHANGED;
var DASHBOARD_SUBSCRIPTIONS_REQUESTED = 'DASHBOARD_SUBSCRIPTIONS_REQUESTED';
exports.DASHBOARD_SUBSCRIPTIONS_REQUESTED = DASHBOARD_SUBSCRIPTIONS_REQUESTED;
var DASHBOARD_SUBSCRIPTIONS_SUCCESS = 'DASHBOARD_SUBSCRIPTIONS_SUCCESS';
exports.DASHBOARD_SUBSCRIPTIONS_SUCCESS = DASHBOARD_SUBSCRIPTIONS_SUCCESS;
var DASHBOARD_SUBSCRIPTIONS_ERROR = 'DASHBOARD_SUBSCRIPTIONS_ERROR';
exports.DASHBOARD_SUBSCRIPTIONS_ERROR = DASHBOARD_SUBSCRIPTIONS_ERROR;
var DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED = 'DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED';
exports.DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED = DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED;
var DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS = 'DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS';
exports.DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS = DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS;
var DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR = 'DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR';
exports.DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR = DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR;
var TOGGLE_DASHBOARD_FILTER = 'TOGGLE_DASHBOARD_FILTER';
exports.TOGGLE_DASHBOARD_FILTER = TOGGLE_DASHBOARD_FILTER;